import { gql } from "@apollo/client";

export const GET_ANNOTATIONS_LIST_BY_IDS_QUERY = gql`
  query AnnotationsByIds($ids: [String]) {
    annotationsByIds(ids: $ids) {
      _id
      name
      nature
      unique_identifier
      representation {
        value
        type
      }
    }
  }
`;
